import styled from 'styled-components/native'

export const Title = styled.Text`
  font-size: 24px;
  font-weight: bold;
  padding: 10px;
`
